<div class="explanation-wrapper" id="explanation-panel">
  <mat-accordion>
    <mat-expansion-panel #explanationPanel>
      <mat-expansion-panel-header data-cy="explanation-panel-header">
        <mat-panel-title>
          {{ 'RESULT.EXPLANATION.HEADLINE' | translate }}
          {{
            clickedPredictionPoint?.date
              | date: 'fullDate' : undefined : translateService.getCurrentLang()
          }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      @if (isLoadingExplanation) {
        <div class="my-4 flex justify-center">
          <mat-spinner [diameter]="loadingSpinnerDiameter"></mat-spinner>
        </div>
      }
      @if (!isLoadingExplanation && predictionExplanations.length) {
        <div>
          <div class="kpi-wrapper">
            <pm-forecast-prediction-kpis
              [forecastDateKpis]="forecastDateKpis"
            ></pm-forecast-prediction-kpis>
          </div>
          <highcharts-chart
            id="explanation-chart"
            [(update)]="chartUpdated"
            [oneToOne]="true"
            [options]="chartOptions"
          >
          </highcharts-chart>
          <mat-card appearance="outlined" class="mt-10">
            <mat-card-content class="bg-gray-100 text-xs">
              {{ 'RESULT.EXPLANATION.BODY' | translate }}
            </mat-card-content>
          </mat-card>
        </div>
      }
      @if (!isLoadingExplanation && !predictionExplanations.length) {
        <div class="my-4 font-medium tex-base flex justify-center">
          <div class="w-full flex flex-col items-center gap-2">
            <pm-icon [icon]="clickIcon" class="text-5xl !size-12"></pm-icon>
            @if (clickedPredictionPoint) {
              <div class="txt">
                {{ 'RESULT.EXPLANATION.NO_DATA' | translate }}
              </div>
            } @else {
              <div class="txt">{{ 'RESULT.EXPLANATION.HINT' | translate }}</div>
            }
          </div>
        </div>
      }
    </mat-expansion-panel>
  </mat-accordion>
</div>
